import React from "react";
import { Dropdown, MenuItem } from "react-bootstrap";

import moment from "moment";

import HSGPopupContainer from '../../../HSGPopup/HSGPopupComponent'

import EpisodeList from "../Episode/EpisodeList";
import StudentCard from "./StudentCard";
import EpisodeForm from "../Episode/EpisodeForm";
import HealthLocker from "../../../HealthLockerContainer";

import { HSGCardV1 } from "../../../../Components/HSGCard/HSGCard";
import HSGCard from "../../../../Components/HSGCard/HSGCard";

import Constants from "../../../../Phi/Constants";

import "./Student.css";

const getPrettyDate = date => format => moment(date).format(format);

class StudentProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultLimit: 20,
            defaultOffset: 0,
            defaultSortField: "modified_time",
            defaultSortBy: "desc",
            defaultSearchString: "",

            episodesList: [],
            episodesTotal: 0,
            episodesHeader: {},

            studentEpisodeHeader: {},

            toggleEpisodeModal: false,

            currentStartNode: null,
            currentBillingId: null
        };
    }

    componentWillMount() {
        this.props.fetchVaccination()
        this.props.fetchNurseMeta()

        // Auto Close Student Profile
        if (!!!this.props.studentId) {
            this.props.closeStudentProfile();
        } else {
            this.initComponent();
        }
    }

    initComponent() {
        let { episodeHeader, studentId, organizationId } = this.props;

        let studentEpisodeHeader = Object.assign(
            this.state.studentEpisodeHeader,
            {},
            {
                inLimit: this.state.defaultLimit,
                inOffset: this.state.defaultOffset,
                inSortField: this.state.defaultSortField,
                inSortBy: this.state.defaultSortBy,
                inStudentId: studentId,
                inOrganizationId: organizationId,
                inSearchString: this.state.defaultSearchString
            }
        );

        this.setState({
            studentEpisodeHeader
        });

        this.props.fetchEpisodeSearch(this.props.buildHeader(studentEpisodeHeader, episodeHeader));
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        // if (this.props.episodeHeader !== nextProps.episodeHeader){
        //     nextProps.fetchEpisodeSearch(
        //         nextProps.buildHeader(
        //             {
        //                 "inStudentId": nextProps.studentId,
        //                 "inOrganizationId": nextProps.organizationId,
        //             },
        //             nextProps.episodeHeader
        //         )
        //     )
        // }

        if((this.props.programs !== nextProps.programs) || (!!!this.state.currentStartNode && this.props.programs)){
            let programs = nextProps.programs
            let program = programs ? programs.filter(element => Constants.getNode(element.events, "Schedule Health Checkup"))[0] : null
            if (program) {
                let progs = Constants.getNode(program.events, "Schedule Health Checkup") 
                
                let scheduledDate = progs.event_custom_json && progs.event_custom_json.event_scheduled_date
                    ? getPrettyDate(progs.event_custom_json.event_scheduled_date)("MMM YYYY")
                    : getPrettyDate(program.billing.billingStartDate)("YYYY")
                
                const newStartNode = this.getStartNode(program.billing.id, this.props.startNodeMap);

                this.setState({currentStartNode: newStartNode, currentBillingId: program.billing.id, currentSelectedDate: scheduledDate})
            }
        }

    }

    _calculateAge() {
        // birthday is a date
        var ageDifMs = Date.now() - new Date(this.props.studentProfile.dob).getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return parseInt((ageDate.getUTCFullYear() - 1970 + ("." + ageDate.getMonth())) * 12);
    }

    _renderEpisodeTimeline = props => (
        <EpisodeList
            dim={props.dim}
            // Attributes for Episode Card
            episodeList={props.episodeList}
            episodeTotal={props.episodeTotal}
            episodeHeader={props.episodeHeader}
            organizationId={props.organizationId}
            studentId={props.studentId}
            buildEpisodeHeader={(newHeader, oldHeader) => props.buildHeader(newHeader, oldHeader)}
            fetchEpisodeSearch={header => props.fetchEpisodeSearch(header)}
            openStudentProfile={studentId => props.openStudentProfile(studentId)}
            noDataAvailable={msg => props.noDataAvailable(msg)}
            baseClass={"col-lg-12 col-md-12 col-sm-12 col-xs-12"}
            episodeCardClass={"col-lg-12 col-md-12 col-sm-12 col-xs-12"}
            showStudentName={false}
            showEpisodeDate={true}
            showEpisodeId={false}
            showProfileLink={false}
            isRenderedInParent={false}
            hideFullEpisode={true}
            showCustomHead={false}
            episodeViewType={"cardView"}
            // Attributes for Episode List
            showBottomDivision={false}
            pagination={false}
            enableSearch={false}
            enableSort={false}
        />
    );

    _renderStudentProfileCard = props => (
        <StudentCard
            dim={props.dim}
            studentProfile={props.studentProfile}
            vaccines={props.vaccines}
            episodeList={props.episodeList}
            closeStudentProfile={props.closeStudentProfile}
            toggleEpisodeModal={flag => this.toggleEpisodeModal(flag)}
            roleType={this.props.roleType}
        />
    );

    toggleEpisodeModal = flag => {
        this.setState({
            toggleEpisodeModal: flag
        });
    };

    closeEpisodeForm = () => {
        this.toggleEpisodeModal(false);
        // this.initComponent()
        // this.props.closeStudentProfile()
    };

    postEpisode = (props, customJson, episodeType) => {
        let { studentId, organizationId } = this.props;

        let studentEpisodeHeader = Object.assign(
            this.state.studentEpisodeHeader,
            {},
            {
                inLimit: this.state.defaultLimit,
                inOffset: this.state.defaultOffset,
                inSortField: this.state.defaultSortField,
                inSortBy: this.state.defaultSortBy,
                inStudentId: studentId,
                inOrganizationId: organizationId,
                inSearchString: this.state.defaultSearchString
            }
        );

        this.setState({
            studentEpisodeHeader
        });

        this.props.postStudentEpisode(props.studentId, customJson, episodeType, studentEpisodeHeader);
    };

    _renderEpisodeFormBody = props => (
        <EpisodeForm
            toggleModal={flag => this.toggleEpisodeModal(flag)}
            postEpisode={(customJson, episodeType) => this.postEpisode(props, customJson, episodeType)}
            toggleEpisodeModal={flag => this.toggleEpisodeModal(flag)}
            closeEpisodeForm={this.closeEpisodeForm}
            metaData={props.metaData}
            age={this._calculateAge()}

            clearForm={() => this.props.clearForm()}
            initializeForm={data => this.props.initializeForm(data)}
        />
    );

    _renderEpisodeFormModal = (props) => (
        <HSGPopupContainer
            show={this.state.toggleEpisodeModal}
            header={'Add Episode'}
            onClose={()=> this.toggleEpisodeModal(false)}
            onSubmit={(data) => this.toggleEpisodeModal(data)}
            onHide={()=> this.toggleEpisodeModal(false)}
            body={this._renderEpisodeFormBody(props)}
        />
    )

    openNewTab = (hsgId, type) => window.open(`/report/student/${this.props.startNodeId}/${type}/${hsgId}`, "_blank");

    handleReportTimeChange = e => {
        const newBillingId = parseInt(e.target.value, 10);
        const newStartNode = this.getStartNode(newBillingId, this.props.startNodeMap);

        this.setState({ currentBillingId: newBillingId, currentStartNode: newStartNode });
    };

    getStartNode = (billingId, s_Map) => {
        for (let eachProgram in s_Map) {
            if (s_Map[eachProgram].billing_id === billingId) return eachProgram;
        }
        return false;
    };


    handleReportYearSelection(index) {

    }

    renderReportSelectionDropdown(eventList) {

        return eventList.map((program, index) => {
            let progs = Constants.getNode(program.events, "Schedule Health Checkup") 
            
            let scheduledDate = progs.event_custom_json && progs.event_custom_json.event_scheduled_date
                ? getPrettyDate(progs.event_custom_json.event_scheduled_date)("MMM YYYY")
                : getPrettyDate(program.billing.billingStartDate)("YYYY")
            
            const newStartNode = this.getStartNode(program.billing.id, this.props.startNodeMap);

            return (
                <MenuItem
                    key={index}
                    eventKey={"" + index}
                    onSelect={ () => this.setState({currentStartNode: newStartNode, currentBillingId: program.billing.id, currentSelectedDate: scheduledDate})}
                >
                    {scheduledDate}
                </MenuItem>
            )
        })
        // return eventList && eventList.length
        //     ? eventList.map((item, pos) => (
        //           <MenuItem
        //               key={pos}
        //               eventKey={"" + pos}
        //               onSelect={eventKey => {
        //                   this.handleReportYearSelection(parseInt(eventKey));
        //               }}
        //           >
        //               {item.name}
        //           </MenuItem>
        //       ))
        //     : null;
    }

    getDropDown = programs => {
        let progs = programs ? programs.filter(element => Constants.getNode(element.events, "Schedule Health Checkup")) : null

        return (

            <Dropdown id="dropdown-select-report-year">
                <span className="hsg-dashboard-dropdown-sry-text-on-head" style={{ float: "left" }}>
                    {this.state.currentSelectedDate}
                </span>

                <Dropdown.Toggle bsStyle="success" className="hsg-dashboard-dropdown-sry-toggle-on-head" />

                <Dropdown.Menu>{this.renderReportSelectionDropdown(progs)}</Dropdown.Menu>
            </Dropdown>
        )
    }

    _renderAssessmentCardReports = () => {
        let metric = [
            {
                heading: "Growth Assessment",
                // body:this.state.reportStatus.growth,
                onClick: () => this.openNewTab(1, "growth")
            },
            {
                heading: "Physical Assessment",
                // body:this.state.reportStatus.physical,
                onClick: () => this.openNewTab(1, "physical")
            },
            {
                heading: "ENT Assessment",
                // body:this.state.reportStatus.ent,
                onClick: () => this.openNewTab(1, "ent")
            },
            {
                heading: "Eye Assessment",
                // body:this.state.reportStatus.eye,
                onClick: () => this.openNewTab(1, "eye")
            },
            {
                heading: "Dental Assessment",
                // body:this.state.reportStatus.dental,
                onClick: () => this.openNewTab(1, "dental")
            }
        ];

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12" style={{ marginTop: 15 }}>
                {metric.map((element, index) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12 no-padding" key={index}>
                        <HSGCard hideHeader style={{ marginBottom: 5, cursor: "pointer" }}>
                            <div className="show-grid" onClick={() => element.onClick}>
                                <div className="student-report-head-text">{element.heading}</div>
                                {/* <div className={
                                    element.body === ButtonReportLink.STATE_NORMAL ? "student-report-body-text-normal" : "student-report-body-text-need-attention"
                                }>
                                    { element.body === ButtonReportLink.STATE_NORMAL ? "Normal" : "Need Attention" }
                                </div> */}
                            </div>
                        </HSGCard>
                    </div>
                ))}
            </div>
        );
    };

    _renderReportContainer = () => this._renderAssessmentCardReports();

    render() {
        let props = this.props;

        return props.studentId ? (
            <div className="container" style={{ paddingTop: 60 }}>
                <div className="col-md-12 col-sm-12 col-xs-12">
                    {props.showStudentProfile ? this._renderStudentProfileCard(props) : null}
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12 no-padding">
                    <div className="col-lg-4 col-md-4 col-sm-12 col-sx-12" style={{marginBottom: 20}}>
                        {/* {this.getYearlyDropDownOnHead(assessmentEventList)} */}
                        {this.getDropDown(props.programs)}
                        {/* {this._renderReportContainer()} */}
                        <div className="" style={{paddingTop: 50}}>
                            {this.props.noDataAvailable("Assessment data not available!")}
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-8 col-sm-12 col-sx-12">
                        {/* <HSGCardV1
                            headingLeft={"Infirmary Timeline"}
                            style={{ height: 400, paddingTop: 10, overflow: "auto", overflowX: "hidden" }}
                        >
                            
                        </HSGCardV1> */}
                            <div style={{padding: 10}}>
                                Episodes
                            </div>
                        <div 
                            className="col-lg-12 col-md-12 col-sm-12 col-sx-12 no-padding" 
                            style={{ maxHeight: 400, paddingTop: 10, overflow: "auto", overflowX: "hidden", marginBottom: 30 }}
                        >
                            
                            {this._renderEpisodeTimeline(props)}
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12">
                        <HSGCardV1
                            headingLeft={"Health Locker"}
                            style={{ height: 400, paddingTop: 10, overflow: "auto", overflowX: "hidden", marginBottom:'8%' }}
                        >
                            <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12">

                                <HealthLocker 
                                    contentNode={
                                        props.studentProfile 
                                        && props.studentProfile.json_value 
                                        && props.studentProfile.json_value.studentContentNodeId
                                    }
                                    studentProfile={props.studentProfile}
                                    documentGroup={Constants.documentGroups.StudentHealthLocker}
                                    isStudent={true}
                                    needToUpdate={true}
                                    hideUpload={false}
                                    asSubContainer={true}
                                    blockEdit={true}
                                /> 
                            </div>
                        </HSGCardV1>
                    </div>
                </div>
                {this.state.toggleEpisodeModal && this._renderEpisodeFormModal(props)}
            </div>
        ) : null;
    }
}

export default StudentProfile;



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Student/StudentProfile.js